<!--行政处罚-->
<template>
  <div class="sanction-container">
    <header-index/>
    <div class="sanction-content">
      <div class="sanction-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>行政处罚</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sanction-top">
        <p class="sanction-title">查询行政处罚</p>
        <el-input placeholder="请输入决定文书号、当事人、事由等关键词" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="getSanctionInfo">
          <el-button type="danger" slot="append" @click="getSanctionInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="sanction-info">
        <div class="sanction-search-menu">
          <span>最新行政处罚</span>
          <div>
            <el-select v-model="region" placeholder="执法地域" style="width: 170px;margin-right: 20px" clearable>
              <el-option :label="'全国'" :value="''"/>
              <el-option v-for="item in provincialCode" :label="item.name" :value="item.code"/>
            </el-select>
            <el-select v-model="office" placeholder="处罚机关" style="width: 170px;margin-right: 20px" clearable>
              <el-option v-for="item in officeItem" :label="item.name" :value="item.name"/>
            </el-select>
            <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="处罚年限" style="width: 170px"/>
          </div>
        </div>
        <div class="sanction-list" v-if="administrativeInfo.length>0">
          <div v-for="info of administrativeInfo" class="sanction-list-item" @click="administrativeDetail(info)">
            <p class="sanction-small-title">{{ info.decisionBookNumber }}</p>
            <p>
              <span class="sanction-gray">处罚日期：</span>
              <span class="sanction-black sanction-200">{{ info.punishDecisionDate || '-' }}</span>
            </p>
            <p>
              <span class="sanction-gray">处罚机关：</span>
              <span class="sanction-black sanction-120">{{ info.decisionOffice || '-' }}</span>
            </p>
            <p>
              <span class="sanction-gray">处罚事由：</span>
              <span class="sanction-black sanction-120">-</span>
            </p>
            <p>
              <span class="sanction-gray">处罚结果：</span>
              <span class="sanction-black sanction-120">{{ info.administrationPunishContent || '-' }}</span>
            </p>
          </div>
        </div>
        <div v-else>
          <el-empty description="暂无内容"/>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <!--行政处罚详情-->
    <el-dialog title="行政处罚详情" :visible.sync="dialogVisible">
      <el-descriptions :column="1" border>
        <el-descriptions-item>
          <template slot="label">决定书文号</template>
          {{ administrativeDetails.decisionBookNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">违法行为类型</template>
          {{ administrativeDetails.illegalActsType || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">处罚决定日期</template>
          {{ administrativeDetails.punishDecisionDate || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">决定机关</template>
          {{ administrativeDetails.decisionOffice || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">处罚变更</template>
          {{ administrativeDetails.penaltyChange || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">行政处罚内容</template>
          {{ administrativeDetails.administrationPunishContent || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import {
  getDecisionOffice,
  searchDdAdministrativeSanction,
  getLawEnforcementRegionByGroup
} from '@/api/enterprise_searchApi'
import {getDdAdministrativeSanctionDetailsById} from '@/api/enterpriseDetailsApi'
export default {
  name: "administrativeSanction",
  components: {Hang, Home_footer, HeaderIndex, page},
  data() {
    return {
      keyword: '',
      cid: 0,
      cityList: {},
      year: '',
      region: '',
      cityJson: cityJson,
      provincialCode: [],
      administrativeInfo: [],
      office: '',
      officeItem: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      administrativeDetails:{},
      dialogVisible:false,
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getSanctionInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getSanctionInfo();
      }
    },
    office(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getSanctionInfo();
      }
    },
  },
  methods: {
    /*获取行政处罚*/
    getSanctionInfo() {
      searchDdAdministrativeSanction({
        decisionOffice: this.office,
        illegalActivitiesType: "",
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        provinceId: this.region || 0,
        punishDecisionDate: this.year
      }).then(res => {
        if (res.code == 200) {
          this.tablePage.total = parseInt(res.content.total);
          this.administrativeInfo = res.content.rows;
          console.log(res.content.rows);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getSanctionInfo();
    },
    /*处罚机关分组*/
    getDecisionOfficeItem() {
      getDecisionOffice().then(res => {
        if (res.code == 200) {
          this.officeItem = res.content;
        }
      })
    },
    /*执法地域分组*/
    getLawEnforcementRegion() {
      getLawEnforcementRegionByGroup().then(res => {
        if (res.code == 200) {
          this.provincialCode = res.content;
        }
      })
    },
    /*获取行政处罚详情*/
    administrativeDetail(info){
      getDdAdministrativeSanctionDetailsById({id:info.id,request:'form'}).then(res=>{
        if (res.code==200){
          console.log('行政处罚详情',res.content)
          this.administrativeDetails=res.content;
          this.dialogVisible=true;
        }
      })
    }
  },
  mounted() {
    this.getSanctionInfo();
    this.getDecisionOfficeItem();
    this.getLawEnforcementRegion();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.sanction-container >>> .sanction-content .sanction-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}
.sanction-container >>> .sanction-content .sanction-top input::-webkit-input-placeholder {
  color: #333333;
}
.sanction-container >>> .sanction-content .sanction-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}
.sanction-container >>> .sanction-content .sanction-top .el-icon-search {
  font-size: 19px;
}
.sanction-container >>> .sanction-content .sanction-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb__inner a,
.sanction-container >>> .sanction-content .sanction-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.sanction-container >>> .sanction-content .sanction-info .sanction-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
.sanction-container >>> .el-descriptions-item__label.is-bordered-label {
  color: #333333;
  background: #D6E9FF;
  width: 160px;
}
.sanction-container >>> .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #D0E0F2;
  padding: 12px 10px;
  font-size: 14px;
  color: #333333;
}
.sanction-container >>> .el-descriptions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.sanction-container >>> .el-descriptions__title {
  font-size: 16px;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
}
.sanction-container >>> .el-descriptions-item__content {
  min-width: 305px;
}
</style>
<style scoped lang="scss">
.sanction-container {
  background: #E7E9F5;
  .sanction-content {
    .sanction-breadcrumb {
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }
    .sanction-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 300px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .sanction-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 70px 0px 50px;
        font-weight: bold;
      }
    }
    .sanction-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .sanction-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;
        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }
      .sanction-list {
        .sanction-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;
          .sanction-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }
          .sanction-gray {
            color: #666666;
            font-size: 14px;
            display: inline-block;
            font-family: "SourceHanSansCN";
            width: 70px;
          }
          .sanction-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
          .sanction-120 {
            width: 93%;
            display: inline-block;
          }
          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
            display: flex;
            align-items: flex-start;
          }
        }
      }
    }
  }
}
</style>